import React from "react";

function Break(props) {
  return <div style={{ margin: props.size }}></div>;
}

export default Break;
